import { render, staticRenderFns } from "./HeaderDashboard.vue?vue&type=template&id=2a84d9ac&scoped=true&lang=pt-br&"
import script from "./HeaderDashboard.vue?vue&type=script&lang=js&"
export * from "./HeaderDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a84d9ac",
  null
  
)

export default component.exports